"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ReactDOM = require("react-dom");
var classNames = require("classnames");
require("./section.less");
var idGenerator_1 = require("spry-react/utils/idGenerator");
var contextMenu_1 = require("spry-react/ContextMenu/contextMenu");
function Section(props) {
    return React.createElement("section", null,
        props.header,
        React.createElement("div", { key: "body", className: classNames('section-body', 'l-box-0', props.className) }, props.children));
}
exports.Section = Section;
var H1SectionHeader = /** @class */ (function (_super) {
    __extends(H1SectionHeader, _super);
    function H1SectionHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    H1SectionHeader.prototype.render = function () {
        return React.createElement("h1", { className: "section-header" }, this.props.children);
    };
    return H1SectionHeader;
}(React.Component));
exports.H1SectionHeader = H1SectionHeader;
var H2SectionHeader = /** @class */ (function (_super) {
    __extends(H2SectionHeader, _super);
    function H2SectionHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    H2SectionHeader.prototype.render = function () {
        return React.createElement("h2", { className: "section-header" }, this.props.children);
    };
    return H2SectionHeader;
}(React.Component));
exports.H2SectionHeader = H2SectionHeader;
var H3SectionHeader = /** @class */ (function (_super) {
    __extends(H3SectionHeader, _super);
    function H3SectionHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    H3SectionHeader.prototype.render = function () {
        return React.createElement("h3", { className: "section-header" }, this.props.children);
    };
    return H3SectionHeader;
}(React.Component));
exports.H3SectionHeader = H3SectionHeader;
var H4SectionHeader = /** @class */ (function (_super) {
    __extends(H4SectionHeader, _super);
    function H4SectionHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    H4SectionHeader.prototype.render = function () {
        return React.createElement("h4", { className: "section-header" }, this.props.children);
    };
    return H4SectionHeader;
}(React.Component));
exports.H4SectionHeader = H4SectionHeader;
var H5SectionHeader = /** @class */ (function (_super) {
    __extends(H5SectionHeader, _super);
    function H5SectionHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    H5SectionHeader.prototype.render = function () {
        return React.createElement("h5", { className: "section-header" }, this.props.children);
    };
    return H5SectionHeader;
}(React.Component));
exports.H5SectionHeader = H5SectionHeader;
var H6SectionHeader = /** @class */ (function (_super) {
    __extends(H6SectionHeader, _super);
    function H6SectionHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    H6SectionHeader.prototype.render = function () {
        return React.createElement("h6", { className: "section-header" }, this.props.children);
    };
    return H6SectionHeader;
}(React.Component));
exports.H6SectionHeader = H6SectionHeader;
var CustomSectionHeader = /** @class */ (function (_super) {
    __extends(CustomSectionHeader, _super);
    function CustomSectionHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CustomSectionHeader.prototype.render = function () {
        return React.createElement("header", { className: "section-header" }, this.props.children);
    };
    return CustomSectionHeader;
}(React.Component));
exports.CustomSectionHeader = CustomSectionHeader;
function SectionHeaderBoxed(props) {
    return React.createElement("header", { className: "section-header section-header-boxed" }, props.children);
}
exports.SectionHeaderBoxed = SectionHeaderBoxed;
function DetailsBody(props) {
    return React.createElement("div", { className: "l-box-h-2x l-box-vb l-box-vt-1-2x" }, props.children);
}
exports.DetailsBody = DetailsBody;
var SectionHeaderContextMenuButton = /** @class */ (function (_super) {
    __extends(SectionHeaderContextMenuButton, _super);
    function SectionHeaderContextMenuButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SectionHeaderContextMenuButton.prototype.render = function () {
        return (React.createElement(contextMenu_1.ContextMenuIndicator, { openContextMenu: this.props.openContextMenuCallback }));
    };
    return SectionHeaderContextMenuButton;
}(React.Component));
exports.SectionHeaderContextMenuButton = SectionHeaderContextMenuButton;
var CollapsibleSection = /** @class */ (function (_super) {
    __extends(CollapsibleSection, _super);
    function CollapsibleSection(props) {
        var _this = _super.call(this, props) || this;
        _this.toggleBlacklistElements = [];
        _this.addToggleBlacklistRef = function (htmlElement) {
            if (htmlElement)
                _this.toggleBlacklistElements.push(htmlElement);
        };
        _this.isEventTargetToggleBlacklisted = function (target) {
            return target instanceof HTMLElement && _this.isHtmlElementToggleBlacklisted(target);
        };
        _this.isHtmlElementToggleBlacklisted = function (toggleTargetElement) {
            return _this.toggleBlacklistElements.some(function (element) {
                return !!$(element).find(toggleTargetElement).length;
            });
        };
        _this.onExpansionToggle = function (e) {
            if (_this.isEventTargetToggleBlacklisted(e.target))
                return;
            _this.toggleExpansion();
        };
        _this.toggleExpansion = function () {
            if (_this.props.onToggle) {
                _this.props.onToggle();
                return;
            }
            _this.setState(function (prevState) {
                var nextExpanded = !prevState.expanded;
                return _this.getTransitionState(nextExpanded);
            });
        };
        _this.onExpandTransitionEnd = function () {
            if (_this.container.current == null)
                return;
            var containerNode = ReactDOM.findDOMNode(_this.container.current);
            containerNode.removeEventListener("transitionend", _this.onExpandTransitionEnd);
            if (_this.state.expanded) {
                _this.setState({ height: null, transition: null });
            }
        };
        _this.state = {
            expanded: !!props.expanded,
            beginTransition: false,
            height: !!props.expanded ? 'auto' : '0',
            transition: null
        };
        _this.container = React.createRef();
        return _this;
    }
    CollapsibleSection.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.expanded !== nextProps.expanded) {
            this.setState(this.getTransitionState(nextProps.expanded || false));
        }
    };
    CollapsibleSection.prototype.getTransitionState = function (expanded) {
        return {
            expanded: expanded,
            beginTransition: true,
            height: expanded ? '0' : 'auto'
        };
    };
    CollapsibleSection.prototype.componentDidUpdate = function () {
        var _this = this;
        //Using the easeOutCubic timing function (from easings.net)
        var easeOut = "cubic-bezier(0.215, 0.61, 0.355, 1)";
        if (this.state.beginTransition) {
            if (this.container.current == null)
                return;
            var containerNode = ReactDOM.findDOMNode(this.container.current);
            if (this.state.expanded) {
                containerNode.addEventListener("transitionend", this.onExpandTransitionEnd);
                this.setState({
                    height: containerNode.scrollHeight.toString() + 'px',
                    transition: "height 250ms " + easeOut,
                    beginTransition: false
                });
            }
            else {
                /* note: we must first set an explicit height, then transition to 0, transitioning from 'auto' does not work */
                if ((this.state.height || "auto") === "auto") {
                    this.setState({
                        height: containerNode.scrollHeight.toString() + "px",
                        transition: "height 250ms " + easeOut
                    });
                }
                else {
                    /* note: the raf is needed in order to ensure the browser actually renders with the explicit height before setting the height to 0 for the transition */
                    requestAnimationFrame(function () { return _this.setState({
                        height: "0",
                        beginTransition: false
                    }); });
                }
            }
        }
    };
    CollapsibleSection.prototype.render = function () {
        var _this = this;
        var containerStyle = {
            display: "block",
            height: this.state.height,
            visibility: this.state.height == "0" ? 'hidden' : undefined,
            overflow: "hidden",
            transition: this.state.transition
        };
        var headerId = idGenerator_1.GenerateId();
        var containerId = idGenerator_1.GenerateId();
        var onKeyPress = function (e) {
            if ((e.key == 'Enter' || e.key == ' ') && !_this.isEventTargetToggleBlacklisted(e.target))
                _this.toggleExpansion();
        };
        return (React.createElement("section", { className: classNames('section-expandable', { 'section-open': this.state.expanded }) },
            React.createElement("header", { className: classNames('section-header', 'section-header-boxed', 'section-header-selectable', { 'active': this.state.expanded }), onClick: this.onExpansionToggle, onKeyPress: onKeyPress, tabIndex: 0, "aria-expanded": this.state.expanded, "aria-controls": containerId, id: headerId, role: "button" },
                React.createElement("a", { className: classNames('section-expander', { 'active': this.state.expanded }) }),
                typeof this.props.header === "function"
                    ? this.props.header(this.addToggleBlacklistRef)
                    : this.props.header),
            React.createElement("div", { className: "section-body l-box-0", style: containerStyle, ref: this.container, id: containerId, role: "region", "aria-labelledby": headerId }, this.props.children)));
    };
    return CollapsibleSection;
}(React.Component));
exports.CollapsibleSection = CollapsibleSection;
